import React from 'react';
import { Checkbox, CircularProgress, Sheet, Stack, Table, Typography } from '@mui/joy';
import FunctionRow from './FunctionRow';

const FunctionsList = ({
  functions,
  loading,
  getFunctionStatus,
  isRunning,
  selectedIds,
  onRun,
  onEdit,
  onDuplicate,
  onDelete,
  onViewLogs,
  onSelectOne,
  onSelectAll,
}) => {
  if (loading && functions.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress size="lg" />
        <Typography level="body-sm" color="neutral" sx={{ mt: 2 }}>
          Loading functions...
        </Typography>
      </Stack>
    );
  }

  if (functions.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <Typography level="body-md" color="neutral">
          No functions match your filters
        </Typography>
        <Typography level="body-sm" color="neutral" sx={{ mt: 1 }}>
          Try adjusting your search or filter criteria.
        </Typography>
      </Stack>
    );
  }

  const allSelected = functions.length > 0 && selectedIds.size === functions.length;
  const someSelected = selectedIds.size > 0 && selectedIds.size < functions.length;

  return (
    <Sheet
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: 'sm',
        overflow: 'auto',
      }}
    >
      <Table
        aria-label="functions table"
        stickyHeader
        hoverRow
        sx={{
          '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
          '--Table-headerUnderlineThickness': '1px',
          '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
          '--TableCell-paddingY': '8px',
          '--TableCell-paddingX': '12px',
        }}
      >
        <thead>
          <tr>
            <th style={{ width: 40 }}>
              <Checkbox
                size="sm"
                checked={allSelected}
                indeterminate={someSelected}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th style={{ width: '18%' }}>Name</th>
            <th style={{ width: '25%' }}>Description</th>
            <th style={{ width: '12%' }}>Type</th>
            <th style={{ width: '10%' }}>Interval</th>
            <th style={{ width: '12%' }}>Last Run</th>
            <th style={{ width: '10%' }}>Status</th>
            <th style={{ width: '13%' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {functions.map((func) => (
            <FunctionRow
              key={func.id}
              func={func}
              status={getFunctionStatus(func)}
              isRunning={isRunning(func.id)}
              selected={selectedIds.has(func.id)}
              onRun={onRun}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
              onViewLogs={onViewLogs}
              onSelect={(f, checked) => onSelectOne(f.id, checked)}
            />
          ))}
        </tbody>
      </Table>
    </Sheet>
  );
};

export default FunctionsList;
